import React from 'react'
import styled from 'styled-components'

interface IPublicOrgan {
  id: string
  name: string
  status: 'Cadastrado' | 'Não cadastrado'
  representativeEmail?: string
  mayorName?: string
  mobile?: string
  representativeName?: string
  numberOfPeople?: number
  hasSecretariat?: boolean
  secretariatName?: string
  secretaryResponsible?: string
}

interface PublicOrganInfoModalProps {
  organ: IPublicOrgan
}

const InfoRow = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  
  &:last-child {
    margin-bottom: 0;
  }
`

const Label = styled.span`
  font-weight: 600;
  color: #464646;
  font-size: 14px;
  line-height: 140%;
  margin-right: 4px;
`

const Value = styled.span`
  color: #464646;
  font-size: 14px;
  line-height: 140%;
  font-weight: 400;
`

const InfoItem = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0;
`

const EmailLink = styled.a`
  color: #0066B3;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

export const PublicOrganInfoModal = ({ organ }: PublicOrganInfoModalProps): JSX.Element => {
  return (
    <div>
      <InfoRow>
        <InfoItem>
          <Label>Nome do Prefeito (a):</Label>
          <Value>{organ.mayorName || '-'}</Value>
        </InfoItem>
      </InfoRow>

      <InfoRow>
        <InfoItem>
          <Label>Nome da prefeitura:</Label>
          <Value>{organ.name || '-'}</Value>
        </InfoItem>
      </InfoRow>

      <InfoRow>
        <InfoItem>
          <Label>Telefone do representante:</Label>
          <Value>{organ.mobile || '-'}</Value>
        </InfoItem>
      </InfoRow>

      <InfoRow>
        <InfoItem>
          <Label>Email do representante:</Label>
          <Value>
            {organ.representativeEmail ? (
              <EmailLink href={`mailto:${organ.representativeEmail}`}>
                {organ.representativeEmail}
              </EmailLink>
            ) : (
              '-'
            )}
          </Value>
        </InfoItem>
      </InfoRow>

      <InfoRow>
        <InfoItem>
          <Label>Número de pessoas envolvidas no programa:</Label>
          <Value>{organ.numberOfPeople || '-'}</Value>
        </InfoItem>
      </InfoRow>

      <InfoRow>
        <InfoItem>
          <Label>Possui Secretaria responsável pela agenda de Inovação em seu Município?</Label>
          <Value>{organ.hasSecretariat ? 'Sim' : 'Não'}</Value>
        </InfoItem>
      </InfoRow>

          <InfoRow>
            <InfoItem>
              <Label>Nome da secretaria responsável pela agenda de Inovação em seu Município:</Label>
              <Value>{organ.secretariatName || '-'}</Value>
            </InfoItem>
          </InfoRow>

          <InfoRow>
            <InfoItem>
              <Label>Nome do responsável pela secretaria:</Label>
              <Value>{organ.secretaryResponsible || '-'}</Value>
            </InfoItem>
          </InfoRow>
    </div>
  )
}

